<template>
  <div class="qrcode" v-if="bShow">
    <div class="dialog-wrapper">
      <div class="head">
        <span class="title">{{$t(title)}}</span>
        <img class="close" @click="hide" src="./close.png" alt="close" width="20" height="20">
      </div>
      <div class="content">
        <img :src="url" alt="QRCode">
        <p class="explain">{{$t('m.wechat_share')}}</p>
      </div>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    props: {
      title: {
        type: String
      },
    },
    data(){
      return {
        id: (() => {
          return loadLocal('id', false);
        })(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        imgprefix: (() => {
          return loadLocal('imgprefix', false);
        })(),
        bShow: false,
        url: '',
      }
    },
    methods: {
      show() {
        this.url = '';
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'InviteTeacher',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let url = encodeURIComponent(response.list[0].inviteurl);
            url = encodeURIComponent(url);
            let title = `${decodeURIComponent(this.schoolNow.roomname)}网校邀请您成为《${decodeURIComponent(this.lessoninfo.lessonname)}》该课程的老师`;
            let subtitle = '接收邀请，成为老师';
            let img = this.lessoninfo.faceimg;
            let finalUrl = response.homepath + `mstudent/index.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
            finalUrl = encodeURIComponent(finalUrl);
            this.url = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
          }
        }).catch((err) => {
        });
        this.bShow = true;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'hidden';
      },
      hide(){
        this.bShow = false;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'auto';
      },
    },
    created(){

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .qrcode
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    overflow: auto
    .dialog-wrapper
      margin: auto
      border-radius: 4px
      overflow: hidden
      background: #ffffff
      .head
        display: flex
        align-items: center
        justify-content: space-between
        height: 60px
        min-width: 430px
        background: #f2f2f2
        .title
          font-size: 20px
          color: #666666
          margin-left: 20px
        .close
          padding: 20px 10px
          cursor: pointer
      .content
        padding 0 20px
        .explain
          padding-bottom: 10px
          font-size: 14px
          color: #333
          line-height: 18px

  /*.content*/
  /*text-align: center*/
  /*.iframe-wrapper*/
  /*body*/
  /*img*/
  /*margin: 0 auto*/
  /*text-align: center*/

</style>



// WEBPACK FOOTER //
// src/components/qrcodepop/QRCodePop.vue